import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls the window to the top on every route change,
 * unless the URL contains a hash (#section) — in which case
 * we let the browser handle the anchor scroll.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // preserve anchor jumps like /#partners
    // Temporarily disable CSS smooth scrolling so the reset is truly instant.
    const html = document.documentElement;
    const prev = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, 0);
    // Restore after paint so anchor/user smooth scroll still works elsewhere.
    requestAnimationFrame(() => {
      html.style.scrollBehavior = prev;
    });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
